export const Categories = [
  { value: "web_app_icon", label: "UI/UX", col: 1 },
  { value: "design", label: "平面", col: 1 },
  { value: "illustration", label: "插画/漫画", col: 1 },
  { value: "home", label: "家居/家装", col: 1 },
  { value: "apparel", label: "女装/搭配", col: 1 },
  { value: "men", label: "男士/风尚", col: 2 },
  { value: "wedding_events", label: "婚礼", col: 2 },
  { value: "industrial_design", label: "工业设计", col: 2 },
  { value: "photography", label: "摄影", col: 2 },

  { value: "modeling_hair", label: "造型/美妆" },
  { value: "food_drink", label: "美食" },
  { value: "travel_places", label: "旅行" },
  { value: "diy_crafts", label: "手工/布艺" },
  { value: "fitness", label: "健身/舞蹈" },
  { value: "kids", label: "儿童" },
  { value: "pets", label: "宠物" },
  { value: "quotes", label: "美图" },
  { value: "people", label: "明星" },
  { value: "beauty", label: "美女" },

  { value: "desire", label: "礼物" },
  { value: "geek", label: "极客" },
  { value: "anime", label: "动漫" },
  { value: "architecture", label: "建筑设计" },
  { value: "art", label: "人文艺术" },
  { value: "data_presentation", label: "数据图" },
  { value: "games", label: "游戏" },
  { value: "cars_motorcycles", label: "汽车/摩托" },

  { value: "film_music_books", label: "电影/图书" },
  { value: "tips", label: "生活百科" },
  { value: "education", label: "教育" },

  { value: "sports", label: "运动" },
  { value: "funny", label: "搞笑" },

  { value: "other", label: "其它" },
  { value: "digital", label: "3C数码" },
];
